export interface SearchFilters {
  date: [Date | null, Date | null];
  notificationType: NotificationType;
  athleteId: string;
}

export const NOTIFICATION_TYPES = ['SMS', 'Email'] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number] | '';
